// Base64URL encode
function base64urlEncode(str: string): string {
  const utf8 = new TextEncoder().encode(str);
  let binary = '';
  utf8.forEach(byte => binary += String.fromCharCode(byte));
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

// Base64URL decode
function base64urlDecode(base64Url: string): string {
  const padding = "=".repeat((4 - (base64Url.length % 4)) % 4);
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/") + padding;
  const binary = atob(base64);
  const utf8 = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    utf8[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(utf8);
}

// Decode JWT
export const decodeJwt = <T = unknown>(token: string | null | undefined): T | null => {
  if (!token) {
    console.error("JWT token is missing.");
    return null;
  }

  try {
    const base64Url = token.split(".")[1];
    const jsonPayload = base64urlDecode(base64Url);
    return JSON.parse(jsonPayload) as T;
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
};

const signature = base64urlEncode("dummy-signature");
export const encodeJwt = (payload: Record<string, unknown>): string => {
  const header = {
    alg: "HS256",
    typ: "JWT",
  };
  const encodedHeader = base64urlEncode(JSON.stringify(header));
  const encodedPayload = base64urlEncode(JSON.stringify(payload));
  return `${encodedHeader}.${encodedPayload}.${signature}`;
};
